{
  "table": {
    "object": "Objeto",
    "type": "Tipo",
    "message": "Mensaje",
    "state": "Estado",
    "actions": "Acciones",
    "createdAt": "Creado",
    "client": "Cliente",
    "userFirstName": "Nombre del usuario",
    "userLastName": "Apellido del usuario",
    "date": "Fecha",
    "amount": "Importe",
    "accountType": "Tipo de cuenta",
    "ticker": "Ticker",
    "currency": "Moneda",
    "price": "Precio",
    "quantity": "Cantidad",
    "organization": "Organización",
    "processDate": "Fecha del proceso",
    "objectType": "Tipo de objeto",
    "effectiveDate": "Fecha de entrada en vigor",
    "settleDate": "Fecha de liquidación",
    "custodianAccountNumber": "Número de cuenta de custodio",
    "clientName": "Nombre del cliente",
    "transaction": "Transacción",
    "subTransaction": "Subtransacción",
    "cusip": "CUSIP",
    "transactionDesc": "Descripción de la transacción",
    "transactionType": "Tipo de transacción",
    "commission": "Comisión",
    "accruedInterest": "Intereses devengados",
    "securityType": "Tipo de seguridad",
    "custodian": "Custodio",
    "account": "Cuenta",
    "flags": "Marcadores",
    "systemUpdated": "Sistema actualizado",
    "externalUpdated": "Actualización externa"
  },
  "state": "Estado",
  "exportProgressTitleFlags": "Exportación de marcadores",
  "exportProgressTitleActivities": "Exportación de actividades",
  "transactionType": "Tipo de transacción",
  "symbol": "Símbolo",
  "custodianAccountNumber": "Número de cuenta de custodio",
  "type": "Tipo",
  "any": "Cualquiera",
  "perPage": "Elementos por página",
  "goTo": "Ir a",
  "tabs": {
    "flags": "Marcadores",
    "activities": "Actividades",
    "jobs": "Empleos"
  },
  "flagState": {
    "FLAGGED": "Marcados",
    "FIXED": "Listo",
    "ALL_FIXED": "Marcar como Listo",
    "ALL_RECONCILE": "Reconciliar todo",
    "ALL_FORCE_RECONCILE": "Forzar reconciliar todo",
    "TRIVIAL": "Trivial"
  },
  "activityState": {
    "CREATED": "Creado",
    "RECONCILED": "Reconciliado",
    "RECONCILE": "Reconciliar",
    "FORCE_RECONCILE": "Reconciliación forzada"
  },
  "jobEventType": {
    "RECONCILIATION": "RECONCILIACIÓN"
  },
  "jobState": {
    "ANY": "CUALQUIERA",
    "INITIATED": "INICIADO",
    "COMPLETED": "COMPLETADO",
    "FAILED": "FALLÓ"
  },
  "eventTable": {
    "eventType": "Tipo de evento",
    "jobName": "Nombre del empleo",
    "ranAt": "Se ejecutó en",
    "updatedAt": "Actualizado",
    "state": "Estado",
    "organization": "Organización",
    "action": "Acción"
  },
  "runReconciliation": {
    "title": "Ejecutar reconciliación",
    "reconcileActivities": "Actividades de reconocimiento",
    "updateCashAndHoldings": "Actualizar efectivo y activos",
    "reconCashAndHoldings": "Reconciliar efectivo y activos",
    "publishSnapshots": "Publicar instantáneas",
    "runReconcileToastMessage": "Reconciliación solicitada"
  },
  "accountSnapshot": {
    "security": "Seguridad",
    "systemQuantity": "Cantidad del sistema",
    "externalQuantity": "Cantidad externa",
    "diffQuantity": "Diferencia de cantidad",
    "systemPrice": "Precio del sistema",
    "externalPrice": "Precio externo",
    "diffPrice": "Diferencia de precio",
    "systemValue": "Valor del sistema",
    "externalValue": "Valor externo",
    "diffValue": "Diferencia de valor",
    "systemBookValue": "Valor contable del sistema",
    "externalBookValue": "Valor contable externo",
    "diffBookValue": "Diferencia del valor contable",
    "ledger": "Libro mayor",
    "transfers": "Transferencias",
    "tradeOrders": "Órdenes comeriales",
    "custodianActivities": "Actividades externas",
    "total": "Total"
  },
  "jobDetails": {
    "title": "Detalles adicionales para {{jobName}} ejecutado el {{ranAt}}"
  },
  "reconFlags": {
    "title": "Reconciliación",
    "summaryTitle": "Panel de resumen",
    "spotlight": {
      "negativeCash": {
        "title": "Efectivo Negativo"
      },
      "negativeHolding": {
        "title": "Posición Negativa"
      },
      "holdingsMismatch": {
        "title": "Discrepancia de Posiciones"
      },
      "moneyAvailableMismatch": {
        "title": "Discrepancia de Dinero Disponible"
      }
    },
    "totalFlags": "Total de marcadores",
    "totalFlagsHint": "MARCADOS en la organización",
    "unresolvedThreePlus": "Sin resolver por más de 3 días",
    "unresolvedThreePlusHint": "MARCADOS, creado hace más de 3 días",
    "severity": {
      "all": "Todos",
      "critical": "Crítico",
      "high": "Alto",
      "medium": "Medio",
      "low": "Bajo"
    },
    "severityLabel": {
      "CRITICAL": "Crítico",
      "HIGH": "Alto",
      "MEDIUM": "Medio",
      "LOW": "Bajo",
      "UNKNOWN": "Desconocido"
    },
    "filters": {
      "flagType": "Tipo de marcador",
      "category": "Categoría",
      "aging": "Antigüedad",
      "any": "Cualquiera",
      "agingOneDay": "1+ día(s)",
      "agingThreeDays": "3+ día(s)",
      "agingSevenDays": "7+ día(s)",
      "clearFilters": "Borrar filtros",
      "priority": "Prioridad"
    },
    "categories": {
      "snapshot": "Instantánea",
      "warning": "Advertencia",
      "cashHoldings": "Efectivo y Posiciones",
      "activity": "Actividad",
      "transfer": "Transferencia",
      "account": "Cuenta",
      "product": "Producto"
    },
    "flagTypes": {
      "NEGATIVE_CASH": "Efectivo negativo",
      "NEGATIVE_HOLDING": "Posición negativa",
      "DIFFERENT_HOLDINGS_V2": "Discrepancia de posiciones",
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": "Discrepancia de dinero disponible"
    },
    "searchPlaceholder": "Buscar por nombre de cliente",
    "searchHelp": "Muestra marcadores para hasta {{max}} cuentas que mejor coinciden. Reduzca su búsqueda si los resultados parecen incompletos.",
    "searchHelpAria": "Acerca de los límites de búsqueda de cuentas",
    "selection": {
      "count": "{{count}} excepciones seleccionadas",
      "selectAllOnPage": "Seleccionar todo en la página",
      "clear": "Borrar selección",
      "dismiss": "Descartar {{count}}",
      "dismissConfirmTitle": "¿Descartar {{count}} marcadores seleccionados?",
      "dismissConfirmBody": "Esto marcará los marcadores seleccionados como resueltos. Esta acción no se puede deshacer desde esta pantalla.",
      "dismissConfirmAction": "Descartar {{count}}"
    },
    "table": {
      "account": "Cuenta",
      "firstSeen": "Visto por primera vez"
    },
    "agingDays_one": "{{count}} día",
    "agingDays_other": "{{count}} días",
    "drawer": {
      "close": "Cerrar",
      "title": "Detalle del marcador",
      "fallbackTitle": "Detalles del marcador",
      "detailsHeading": "Detalles",
      "summary": {
        "type": "Tipo:",
        "account": "Cuenta:",
        "date": "Fecha:",
        "firstSeen": "Visto por primera vez:"
      },
      "followUpTask": "Crear tarea de seguimiento",
      "resolve": "Resolver",
      "resolveSuccess": "Marcador resuelto",
      "resolveError": "No se pudo resolver este marcador",
      "tabs": {
        "overview": "Resumen",
        "rawJson": "JSON sin procesar",
        "notes": "Notas"
      },
      "sections": {
        "issueSummary": "Resumen del problema",
        "flagSummary": "Resumen del marcador",
        "account": "Cuenta",
        "activity": "Actividad y transferencia de custodio",
        "systemIdentifiers": "Identificadores del sistema",
        "additional": "Detalles adicionales"
      },
      "fields": {
        "flagType": "Tipo de marcador",
        "objectType": "Tipo de objeto",
        "priority": "Prioridad",
        "created": "Creado",
        "state": "Estado",
        "custodianAcctShort": "N.º de cuenta de custodio",
        "accountStatus": "Estado de la cuenta",
        "transactionId": "ID de transacción",
        "subTransactionId": "ID de subtransacción",
        "financialProductId": "ID de producto financiero",
        "activityType": "Tipo",
        "activityStatus": "Estado",
        "firstSeen": "Visto por primera vez"
      },
      "internalNotesHeading": "Notas internas",
      "notesLabel": "Notas",
      "notesPlaceholder": "Añada notas sobre su investigación…",
      "notesSaved": "Notas guardadas",
      "notesSaveError": "No se pudieron guardar las notas",
      "discardDraftConfirmTitle": "¿Descartar nota sin guardar?",
      "discardDraftConfirmBody": "Tiene una nota que no se ha guardado. ¿Cerrar sin guardar?",
      "discardDraftConfirmAction": "Descartar y cerrar",
      "dismissSuccess": "Marcador descartado",
      "dismissError": "No se pudo descartar este marcador",
      "notesHistoryEmptyTitle": "Aún no hay notas",
      "notesHistoryEmptyReadOnlyTitle": "No hay notas para este marcador",
      "notesHistoryEmptyDescription": "Añada una nota para capturar contexto importante sobre este marcador.",
      "addNote": "Añadir nota"
    },
    "bulkDismissError": "No se pudieron descartar los marcadores seleccionados",
    "bulkDismissSuccess": "{{count}} marcadores descartados",
    "bulkDismissPartial": "{{failed}} de {{total}} marcadores no pudieron ser descartados",
    "bulkDismissNoFlaggedSelected": "Ninguno de los marcadores seleccionados puede ser descartado. Solo los marcadores señalados pueden resolverse desde esta vista.",
    "emptyTable": "Ningún marcador coincide con los filtros actuales.",
    "pagination": {
      "summary": "Mostrando {{start}}–{{end}} de {{total}} marcadores"
    },
    "flagState": {
      "FLAGGED": "Marcados",
      "FIXED": "Listo",
      "TRIVIAL": "Trivial"
    },
    "emptyTableHint": "Intente ajustar sus filtros o búsqueda.",
    "emptyTableNoResults": "No se encontraron marcadores.",
    "emptyTableNoData": "No hay datos disponibles.",
    "agingHelp": "Días desde que este problema fue <bold>observado por primera vez</bold> (Visto por primera vez). El marcador puede actualizarse diariamente cuando la reconciliación reemite el mismo problema; esto <bold>no</bold> restablece la antigüedad. Resuelva o descarte cuando esté solucionado.",
    "agingHelpAria": "Acerca de la columna de antigüedad",
    "searchError": "La búsqueda de clientes falló. Inténtelo de nuevo."
  },
  "flagGlossary": {
    "title": "Glosario de marcadores",
    "openGlossary": "Glosario",
    "backToFlags": "Volver a los marcadores",
    "searchPlaceholder": "Buscar marcadores",
    "loadError": "No se pudo cargar el glosario de marcadores. Inténtelo de nuevo.",
    "emptyTable": "Ningún marcador coincide con los filtros actuales.",
    "emptyTableHint": "Intente ajustar sus filtros o búsqueda.",
    "emptyTableNoResults": "No se encontraron marcadores.",
    "emptyTableNoData": "No hay datos disponibles del glosario de marcadores.",
    "emptyTableError": "No se pudieron cargar los marcadores.",
    "emptyTableErrorHint": "Algo salió mal. Inténtelo de nuevo.",
    "filters": {
      "category": "Categoría",
      "clearFilters": "Borrar filtros"
    },
    "kpi": {
      "total": "Total de marcadores disponibles",
      "totalHint": "Todos los tipos de marcadores en el glosario",
      "thresholded": "Marcadores con umbral",
      "thresholdedHint": "Marcadores que admiten umbrales de cantidad o porcentaje",
      "turnedOff": "Desactivados",
      "turnedOffHint": "Tipos de marcadores deshabilitados para esta organización"
    },
    "table": {
      "flagName": "Nombre del marcador",
      "description": "Descripción",
      "exampleTrigger": "Ejemplo de activación",
      "category": "Categoría",
      "actualPriority": "Prioridad actual",
      "actualThreshold": "Umbral actual",
      "defaultPriority": "Prioridad predeterminada",
      "defaultThreshold": "Umbral predeterminado"
    },
    "pagination": {
      "summary": "Mostrando {{start}}–{{end}} de {{total}} tipos de marcadores"
    },
    "entries": {
      "INVALID_BOOK_VALUE_AMOUNT": {
        "description": "Una actividad de cambio en el archivo del custodio tiene cantidad, precio y símbolo válidos, pero el importe del valor contable no es válido (por ejemplo, un cambio de entrada requiere un valor contable > 0; un cambio de salida requiere un valor contable < 0).",
        "exampleTrigger": "Cambio de entrada para ABC tiene una cantidad de 10 y un precio, pero bookValueAmountCents es 0 o falta → “SWI listado en el archivo de actividad, pero el importe del valor contable no es válido.”"
      },
      "FEE_NOT_FOUND": {
        "description": "Una actividad de comisión aparece en el feed del custodio, pero no se encontró ninguna transferencia de retiro de comisión coincidente en la plataforma (en estado SOLICITADO).",
        "exampleTrigger": "Aparece una comisión de gestión de $25 en el archivo de actividad del custodio para la cuenta, pero no existe una transferencia de comisión correspondiente en la plataforma para conciliarla."
      },
      "FEE_AMOUNT_DIFFERENT": {
        "description": "El importe de la actividad de comisión del custodio no coincide con la suma de las transferencias de retiro de comisión SOLICITADAS de la plataforma (agrupadas por origen). El servicio de marcadores puede suprimir por debajo de un umbral de dólar (centavos) configurado por la organización.",
        "exampleTrigger": "La comisión del custodio es de $125.00 y la suma de los retiros de comisiones de la plataforma es de $100.00 → se activa el marcador a menos que el umbral de la organización cubra la diferencia de $25.00."
      },
      "TRADE_NOT_FOUND": {
        "description": "Aparece una operación en el archivo de actividad del custodio, pero no se encontró ninguna operación coincidente en la plataforma para conciliarla.",
        "exampleTrigger": "La actividad del custodio muestra una COMPRA de VOO, pero no hay una operación EN PROCESO coincidente en la plataforma."
      },
      "ACCOUNT_NOT_FOUND": {
        "description": "Una actividad o registro hace referencia a un número de cuenta que no existe en el sistema donde se espera que se encuentre.",
        "exampleTrigger": "La actividad del custodio hace referencia a un número de cuenta que no está registrado en la plataforma."
      },
      "TRANSFER_NOT_FOUND": {
        "description": "Una actividad relacionada con una transferencia aparece en el archivo de actividad del custodio (o una liquidación entrante no tiene candidatos en curso), pero no se encontró ninguna transferencia de plataforma coincidente.",
        "exampleTrigger": "El custodio registra una liquidación entrante de $10,000 y la subcuenta no tiene candidatos de transferencia externa SOLICITADOS/EN PROCESO → se activa el marcador. (Otras rutas utilizan el mismo patrón de “listado en el archivo de actividad, pero no encontrado”)."
      },
      "UNKNOWN_ACTIVITY_TYPE": {
        "description": "Un código o tipo de actividad reportado por el custodio o el sistema no coincide con ningún tipo de actividad reconocido en la configuración de mapeo.",
        "exampleTrigger": "El feed del custodio incluye el código de actividad \"XYZ\" sin un mapeo correspondiente a un tipo de actividad conocido."
      },
      "FINANCIAL_PRODUCT_NOT_FOUND": {
        "description": "Una actividad o posición hace referencia a un producto financiero (valor, fondo, etc.) que no existe en el catálogo de productos.",
        "exampleTrigger": "Una operación hace referencia al CUSIP 123456789, pero no existe ningún registro de producto financiero coincidente en el sistema."
      },
      "NOT_CORPORATE_ACCOUNT": {
        "description": "Se encontró un tipo de actividad que solo se espera en cuentas corporativas registrado en un tipo de cuenta no corporativa.",
        "exampleTrigger": "Una actividad de acción corporativa se registra en una cuenta individual sujeta a impuestos en lugar de una cuenta corporativa."
      },
      "TOO_MANY_EXTERNAL_TRANSFER_IN_CANDIDATES_FOUND": {
        "description": "Más de un registro de transferencia del custodio coincide con los detalles de una única transferencia entrante esperada, lo que impide la coincidencia automática.",
        "exampleTrigger": "Tres transferencias de custodio separadas coinciden con la misma referencia de depósito y cantidad, por lo que el sistema no puede resolver automáticamente cuál aplicar."
      },
      "CURRENCY_IS_NOT_AVAILABLE": {
        "description": "Una actividad hace referencia a una moneda que no está habilitada o admitida para la conexión del custodio de la cuenta.",
        "exampleTrigger": "Una operación está denominada en una moneda que no ha sido habilitada para esa conexión de custodio."
      },
      "NSF_REBOOKING_DETECTED": {
        "description": "Se omite una actividad NSF porque se detectó un patrón de recontabilización del custodio: existe un par EFT/CXLEFT con el mismo importe absoluto, cuenta, fecha de análisis y moneda (a menudo utilizado cuando el custodio actualiza los códigos de contribuyente).",
        "exampleTrigger": "Un NSF de −$500 y un EFT de +$500 se registran en la misma cuenta y fecha de análisis → se omite el NSF y se activa este marcador."
      },
      "HBP_WITHDRAW_TRANSFER_NOT_FOUND": {
        "description": "Una actividad de retiro del Plan de Compra de Vivienda (HBP) aparece en el archivo de actividad del custodio, pero no se encontró ningún retiro de USUARIO de la plataforma coincidente EN PROCESO con el motivo Plan de Compra de Vivienda (esperado en REER / REER conyugal).",
        "exampleTrigger": "El custodio muestra un retiro HBP de $35,000 en un REER, pero la plataforma no tiene ningún retiro HBP EN PROCESO por ese importe para conciliar."
      },
      "EFT_ACTIVITY_NOT_FOUND": {
        "description": "Una actividad NSF hace referencia a un subTransactionId que no tiene una actividad EFT o de retiro interno (WDL) previa coincidente en el feed del custodio para esa cuenta y moneda.",
        "exampleTrigger": "Se recibe un NSF de −$1,200 con subTransactionId=ABC-99, pero no existe ninguna actividad EFT o WDL con ese subTransactionId → se activa el marcador."
      },
      "TRANSFER_AMOUNT_DIFFERENT": {
        "description": "Un importe de liquidación de custodio entrante está fuera del ±10% de todos los candidatos de transferencias externas en curso (SOLICITADAS/EN PROCESO) en la subcuenta, por lo que se bloquea la coincidencia automática.",
        "exampleTrigger": "La liquidación es de $10,000, pero el único candidato en curso es de $8,500 (15% de diferencia) → se activa el marcador para la reconciliación manual."
      },
      "TRANSFER_IMPORT_FAILED": {
        "description": "Una fila de transferencia en el archivo de trabajo de importación de transferencias del custodio fue clasificada como FALLIDA y no se importó correctamente.",
        "exampleTrigger": "El archivo de importación marca la transferencia 64a1… como FALLIDA → el mensaje del marcador hace referencia a esa clave del archivo de importación."
      },
      "TRANSFER_STUCK_PROCESSING": {
        "description": "Una transferencia de origen de USUARIO ha permanecido en Procesamiento más tiempo que el SLA de 2 días hábiles (basado en el último cambio de estado a Procesamiento).",
        "exampleTrigger": "Un retiro de USUARIO pasó a Procesamiento el lunes y sigue en Procesamiento el miércoles (2 días hábiles) → se activa el marcador."
      },
      "TRANSFER_STUCK_INITIATED": {
        "description": "Un retiro de USUARIO ha permanecido en Iniciado durante la ventana SLA de 3 días hábiles sin progresar.",
        "exampleTrigger": "Un retiro de USUARIO entró en Iniciado hace exactamente 3 días hábiles y todavía está en Iniciado → se activa el marcador."
      },
      "TRANSFER_STUCK_READY": {
        "description": "Una transferencia de origen de USUARIO ha permanecido en Listo más tiempo que el SLA de 3 días hábiles, o el envío del custodio devolvió un motivo de fallo que activa el mismo tipo de marcador.",
        "exampleTrigger": "Un depósito de USUARIO ha estado en Listo durante más de 3 días hábiles sin progresar → se activa el marcador."
      },
      "FAILED_ACCOUNT": {
        "description": "La configuración o el aprovisionamiento de la cuenta fallaron en algún momento del proceso y requieren un seguimiento operativo para su resolución.",
        "exampleTrigger": "La creación de la cuenta se completó en la plataforma, pero la incorporación del custodio devolvió un estado de fallo."
      },
      "FAILED_CUSTODIAN_OPENING": {
        "description": "La apertura de la cuenta del custodio (o, en algunas rutas, el envío de la transferencia) devolvió una lista de tareas pendientes en lugar de completarse con éxito.",
        "exampleTrigger": "El webhook de apertura de cuenta devuelve una lista de tareas pendientes → FAILED_CUSTODIAN_OPENING se publica con el mensaje “La apertura de la cuenta del custodio devolvió una lista de tareas pendientes.”"
      },
      "FAILED_CUSTODIAN_ACCOUNT_OPENING": {
        "description": "El envío de la solicitud de apertura de cuenta del custodio falló gravemente (excepción / apertura fallida), por lo que no se estableció ninguna cuenta de custodio confirmada.",
        "exampleTrigger": "submitCustodianAccountOpening falla con un tiempo de espera de conexión → marcador “La apertura de la cuenta del custodio falló.”"
      },
      "ACCOUNT_CLOSED": {
        "description": "El archivo AccountInfo de fin de día del custodio marca la cuenta como CERRADA (Estado=CERRADA o FechaCierre establecida) mientras que la cuenta de la plataforma sigue activa (con función restringida).",
        "exampleTrigger": "La cuenta de custodio 12345678 está CERRADA en AccountInfo; la cuenta de la plataforma sigue ACTIVA → “La cuenta 12345678 está marcada como CERRADA por el custodio.”"
      },
      "TOTAL_MARKET_VALUE_INCORRECT": {
        "description": "El valor de mercado de la cuenta cayó más del 15% (predeterminado) en comparación con la instantánea de reconciliación del día anterior. Los aumentos se ignoran.",
        "exampleTrigger": "El valor de mercado de OneVest del día anterior era de $100,000; el día actual es de $80,000 (−20%) con un umbral predeterminado del 15% → se activa el marcador."
      },
      "STATEMENT_NOT_FOUND": {
        "description": "No se encontró ningún estado de cuenta para el mes anterior para una cuenta de custodio que aún tiene valor de mercado en la plataforma.",
        "exampleTrigger": "La cuenta 98765432 tiene un valor de mercado de $12,500, pero no hay estado de cuenta para junio de 2026 → se activa el marcador."
      },
      "CASH_NOT_FOUND": {
        "description": "No se pudo localizar un saldo de efectivo o una partida de efectivo esperados durante la reconciliación.",
        "exampleTrigger": "La instantánea del custodio incluye un saldo de efectivo, pero la plataforma no tiene ningún registro de efectivo correspondiente para la cuenta."
      },
      "HOLDING_NOT_FOUND": {
        "description": "El custodio informa una posición que no existe en los registros de la plataforma para esa cuenta.",
        "exampleTrigger": "El custodio informa 200 acciones de XYZ, pero la plataforma no muestra ninguna posición para ese símbolo."
      },
      "HOLDING_NOT_FOUND_IN_CUSTODIAN": {
        "description": "Existe una posición en los registros de la plataforma, pero no se encontró en las posiciones del custodio para esa cuenta.",
        "exampleTrigger": "La plataforma muestra 100 acciones de ABC, pero las posiciones del custodio no incluyen ese símbolo."
      },
      "MONEY_AVAILABLE_VALUE_INCORRECT_V2": {
        "description": "Después de la reconciliación de efectivo, el dinero disponible de la plataforma no es igual al dinero disponible en la instantánea del custodio (misma moneda). La publicación puede suprimirse solo si una organización configura un umbral de centavos (o porcentaje); no hay un umbral predeterminado de la plataforma.",
        "exampleTrigger": "El dinero disponible de la plataforma es de $999.00 y la instantánea del custodio muestra $1,000.00 → se activa el marcador a menos que el umbral de la organización absorba la diferencia de $1.00."
      },
      "DIFFERENT_HOLDINGS_V2": {
        "description": "Después de la reconciliación de posiciones, la cantidad de la plataforma para un símbolo no es igual a la cantidad del archivo de posiciones del custodio. La publicación puede suprimirse solo si una organización configura un umbral porcentual; no hay un porcentaje predeterminado de la plataforma.",
        "exampleTrigger": "El archivo de posiciones muestra 100 acciones de XYZ y la plataforma muestra 90 → se activa el marcador a menos que el umbral porcentual de la organización permita esa diferencia."
      },
      "NEGATIVE_CASH": {
        "description": "El saldo de efectivo en una cuenta ha caído por debajo de cero.",
        "exampleTrigger": "La posición de efectivo de una cuenta es negativa después de que se liquida una operación."
      },
      "NEGATIVE_HOLDING": {
        "description": "Una posición de seguridad muestra una cantidad negativa de acciones o unidades.",
        "exampleTrigger": "La cantidad de posiciones para un símbolo se registra como inferior a cero."
      },
      "PENDING_TRANSACTION_MONEY_AVAILABLE_VALUE_INCORRECT": {
        "description": "Igual que Dinero Disponible V2, pero la comparación utiliza el dinero disponible ajustado por transacciones pendientes.",
        "exampleTrigger": "Después de ajustar por operaciones pendientes, el disponible en la plataforma es de $5,000, pero la instantánea del custodio implica $5,200 → se activa el marcador (sujeto al umbral de la organización)."
      },
      "PENDING_TRANSACTION_DIFFERENT_HOLDINGS": {
        "description": "Igual que Discrepancia de Posiciones V2, pero las cantidades se ajustan por transacciones pendientes antes de comparar.",
        "exampleTrigger": "Después de las ventas pendientes, la plataforma proyecta 50 acciones de ABC, pero el archivo del custodio todavía muestra 60 → se activa el marcador (sujeto al umbral de la organización)."
      },
      "DIFFERENT_BOOKVALUE": {
        "description": "El valor contable en el archivo de posiciones del custodio difiere del valor contable de la plataforma para un símbolo (solo cuando los marcadores de valor contable están habilitados). Puede estar limitado por un umbral de centavos de la organización.",
        "exampleTrigger": "El valor contable del archivo de posiciones es de $1,000 y el valor contable de la plataforma es de $1,050 para ABC → se activa el marcador cuando la función está activada."
      },
      "NO_SNAPSHOTS_RECEIVED": {
        "description": "No se recibieron SubAccountDailyStats (instantáneas diarias históricas) para la fecha esperada.",
        "exampleTrigger": "Para el 07/21/2026, el historial tiene cero filas de estadísticas diarias → “No se recibieron instantáneas diarias para el 07/21/2026.”"
      },
      "SNAPSHOT_MISSING": {
        "description": "Existe una instantánea diaria del día anterior para una subcuenta, pero falta la fila de SubAccountDailyStats de hoy.",
        "exampleTrigger": "La subcuenta tenía estadísticas ayer, pero ninguna para el 07/21/2026 → “Falta la instantánea para la subcuenta {id} 07/21/2026.”"
      },
      "SNAPSHOT_ANOMALY": {
        "description": "Los campos de contribución de la instantánea diaria son inconsistentes: en la primera instantánea, el valor de mercado / contribución neta / nueva contribución son desiguales por pares; de lo contrario, newContributionCents no es igual al cambio día a día en la contribución neta.",
        "exampleTrigger": "La contribución neta de ayer fue de $1,000 y hoy es de $1,100, pero newContributionCents es de $50 (no $100) → se activa el marcador."
      },
      "SNAPSHOT_PRICE_NOT_FOUND": {
        "description": "No se pudo localizar un precio de mercado necesario para valorar una posición en una instantánea para esa fecha.",
        "exampleTrigger": "Una instantánea lista el símbolo XYZ, pero no hay precio de mercado disponible para la fecha de la instantánea."
      },
      "NOT_ENOUGH_MONEY_AVAILABLE_IN_ACCOUNT": {
        "description": "No se puede procesar un retiro total porque el dinero disponible en la cuenta (después de sumar los saldos disponibles negativos) es insuficiente.",
        "exampleTrigger": "El retiro total apunta a $5,000, pero otras subcuentas contribuyen con −$6,000 disponibles → “No se puede procesar el retiro total debido a que no hay suficiente dinero disponible en una cuenta.”"
      },
      "RISKY_DIFFERENT_HOLDING_MF_SELL_ALL": {
        "description": "Para una operación de venta total de fondos mutuos, la cantidad esperada frente a la cantidad de actividad del custodio difiere en al menos un 10% (la organización debe permitir la lógica de transacciones pendientes; el porcentaje predeterminado del servicio de marcadores es del 10%).",
        "exampleTrigger": "La venta total espera una cantidad de 100, pero la cantidad de actividad es de 85 (15% de discrepancia) → se activa el marcador."
      },
      "RISKY_DIFFERENT_HOLDING_USD_ETF": {
        "description": "Para una operación de ETF en USD, el valor esperado frente al valor de la actividad (cantidad × precio) difiere en al menos un 10% (misma restricción que la venta total de fondos mutuos).",
        "exampleTrigger": "La operación asignó $10,000, pero el valor de ejecución es de $8,500 (15% de discrepancia de valor) → se activa el marcador."
      }
    }
  },
  "flagsMovedModal": {
    "title": "Los marcadores se han movido",
    "body": "Los marcadores ahora residen en su propio panel con nuevos filtros, resúmenes y una vista detallada. Será redirigido(a) allí ahora.",
    "confirm": "Ir a Marcadores"
  },
  "activitiesMovedModal": {
    "title": "Las actividades se han movido",
    "body": "Las actividades ahora residen en su propio panel con métricas y una lista de trabajo rediseñada. Será redirigido(a) allí ahora.",
    "confirm": "Ir a Actividades"
  },
  "activitiesV3": {
    "pageTitle": "Actividades",
    "pageSubtitle": "Supervise las métricas y el trabajo pendiente de la reconciliación de actividades del custodio.",
    "tablePlaceholder": "Lista de trabajo de actividades próximamente",
    "chartSlot": {
      "placeholder": "Gráfico de antigüedad del trabajo pendiente próximamente"
    },
    "metrics": {
      "error": "No se pudieron cargar las métricas de actividad.",
      "occurringToday": {
        "title": "Ocurriendo hoy",
        "hint": "Actividades que ocurren hoy (UTC)"
      },
      "created": {
        "title": "Creado",
        "hint": "Trabajo pendiente (todo el tiempo)"
      },
      "reconciledToday": {
        "title": "Reconciliado hoy",
        "hint": "Reconciliado hoy (UTC)"
      },
      "agingPending": {
        "title": "Antigüedad pendiente",
        "hint": "Pendiente 3+ días (UTC)"
      }
    },
    "filters": {
      "state": "Estado",
      "stateCreated": "Creado",
      "stateReconciledToday": "Reconciliado (hoy)",
      "type": "Tipo",
      "aging": "Antigüedad",
      "any": "Cualquiera",
      "agingOneDay": "1+ día(s)",
      "agingThreeDays": "3+ día(s)",
      "agingSevenDays": "7+ día(s)",
      "search": "Buscar",
      "searchPlaceholder": "Cliente, n.º de cuenta o ticker",
      "clearFilters": "Borrar filtros",
      "expandAll": "Expandir todo",
      "collapseAll": "Contraer todo"
    },
    "table": {
      "client": "Cliente",
      "organization": "Organización",
      "date": "Fecha",
      "type": "Tipo",
      "custodianAcct": "Cuenta de custodio",
      "amount": "Importe",
      "acctType": "Tipo de cuenta",
      "state": "Estado",
      "aging": "Antigüedad",
      "reconciledVia": "Reconciliado vía",
      "empty": "Ninguna actividad coincide con los filtros actuales.",
      "detailPlaceholder": "Detalle de actividad próximamente",
      "ticker": "Símbolo bursátil"
    },
    "bulk": {
      "selectedCount": "{{count}} seleccionado(s)",
      "selectAllOnPage": "Seleccionar todo en la página",
      "clearSelection": "Borrar selección",
      "retry": "Reintentar en masa"
    }
  }
}
